import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e8472bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accounts-balance container-inner" }
const _hoisted_2 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_3 = { class: "col-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "accounts-balance__title" }, "Total Balance", -1))
const _hoisted_5 = { class: "accounts-balance__amount" }
const _hoisted_6 = { class: "accounts-balance__fiat" }
const _hoisted_7 = { class: "col-4 row justify-content-end" }

import BaseButton from "@/components/base-button/index.vue";
import { computed, PropType } from "vue";
import { Token } from "@/types/token";
import BigNumber from "bignumber.js";
import { nativeToken } from "@/stores";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'accounts-balance',
  props: {
  balance: {
    type: Object as PropType<BigNumber>,
    default: new BigNumber(0),
  },
  token: {
    type: Object as PropType<Token>,
    default: nativeToken,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();



const totalUsdValue = computed(() => {
  return props.balance.times(props.token.price);
});

const navigateToSend = () => {
  router.push({
    name: "send",
  });
};

const navigateToStake = () => {
  router.push({
    name: "stake",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h2", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.balance)) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$filters.currencyFormat(totalUsdValue.value, "USD")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseButton, {
          title: "Stake",
          stroke: true,
          small: true,
          action: navigateToStake
        }),
        _createVNode(BaseButton, {
          title: "Send",
          stroke: true,
          small: true,
          action: navigateToSend
        })
      ])
    ])
  ]))
}
}

})